import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { ActivatedRoute, Router } from '@angular/router';
import { Dominio, DominioFilter } from '@core/models/dominio';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DialogService } from '@core/services/dialog.service';
import { DominiosService } from '@core/services/dominios.service';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { AuthenticationService } from '@core/auth/authentication.service';
import { MessageService } from '@core/services/message.service';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { DominiosSharedDataService } from '@modules/dominios/dominios-shared-data.service';
import { ColumnOrder } from '@core/table/order';
import { TipoEntidadeService } from '@core/services/tipoentidade.service';
import { RoleEnum } from '@core/models/role';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';

import { RouteAction } from '@core/action/action';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-dominio-tree-list',
  templateUrl: './dominio-tree-list.component.html',
  styleUrls: ['./dominio-tree-list.component.css']
})
export class DominioTreeListComponent implements OnInit, AfterViewInit {

  // DominioHierarquia
  dataSet: Dominio[] = [];
  titulo!: string;
  nomeDominio!: string;
  nomeTratadoDominio!: string;
  descricaoDominio!: string;

  dominioFilterForm!: FormGroup;
  filtro = new DominioFilter();
  roleEnum = RoleEnum;
  columOrder: ColumnOrder | undefined;
  tipoEntidadeList: any[] = [];

  colunasVisiveis: string[] = [];
  size: NzButtonSize = 'large';
  isEditing = false;
  nzFilterOption = (): boolean => true;
  cargoReferenciaList: any[] = [];
  subTipoList: any[] = [];
  especializacaoSubtipoList: any[] = [];
  incluirInativos = false;
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  pesquisaInicialRealizada: boolean = false;

  constructor(
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    private dominiosService: DominiosService,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private router: Router,
    private modalService: NzModalService,
    private dominiosSharedDataService: DominiosSharedDataService,
    private appSignalDataService: AppSignalDataService,
    private tipoEntidadeService: TipoEntidadeService,
    private cargoReferenciaService: CargoReferenciaService,
    private service: DominiosService,
  ) { }

  ngOnInit() {
    this.parametros();
    this.criarFormulario();
    this.carregarListas();
    this.carregaComboSubTipo();
    this.carregaComboEspecializacao();
  }

  criarFormulario(): void {
    this.dominioFilterForm = this.formBuilder.group({
      tipoEntidade: ['', Validators.required],
      subTipo: ['', Validators.required],
      idEspecificacao: [undefined]
    });
  }

  carregarListas(): void {
    forkJoin({
      tiposEntidade: this.tipoEntidadeService.listarPorTipoEnum(),
      cargosReferencia: this.cargoReferenciaService.listar()
    }).subscribe(({ tiposEntidade, cargosReferencia }) => {
      this.tipoEntidadeList = tiposEntidade;
      this.cargoReferenciaList = cargosReferencia;
    });
  }

  carregaComboSubTipo() {
    this.tipoEntidadeControl.valueChanges.subscribe((value: any) => {
      const id = value?.id ?? value;
      if (!value) {
        this.resetarItensMudarEntidade();
        return;
      }
      if (id) {
        this.tipoEntidadeService.listarSubTiposEntidade(id).subscribe((subTipos) => {
          this.subTipoList = subTipos;
          // this.subTipoControl.setValue(subTipos[0]?.id);
          this.resetarItensMudarEntidade();
        });
      } else {
        this.resetarItensMudarEntidade();
      }
    });
  }

  resetarItensMudarEntidade() {
    this.pesquisaInicialRealizada = false;
    this.subTipoControl.setValue(null);
    // this.especificacaoControl.setValue(null);
    this.dataSet = [];
  }

  carregaComboEspecializacao() {
    const orgao = 9;
    this.subTipoControl?.valueChanges.subscribe((subTipo: any) => {
      if (this.tipoEntidadeControl.value == orgao) {
        // this.especificacaoControl.setValue(null);
        this.especializacaoSubtipoList = [];

        if (subTipo) {
          this.tipoEntidadeService.listarEspecificacoesPorSubTipo(subTipo).subscribe((res: any) => {
            this.especializacaoSubtipoList = res;
          });
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();

    this.route.data.subscribe((data) => {
      if (data['dominio']) {
        this.titulo = data['dominio'].descricao;
        this.nomeDominio = data['dominio'].nome;
      }
    });
  }

  pesquisar(): void {
    if (this.dominioFilterForm.valid) {
      this.filtro = { ...this.dominioFilterForm.getRawValue() };
      this.pesquisaInicialRealizada = true;

      if (this.paginator?.reset) {
        this.paginator.reset();
      }

      this.consultar();
    } else {
      this.messageService.error('Por favor, preencha todos os campos obrigatórios.');
    }
  }

  consultar(): void {
    const paginacao = this.paginator?.pagination;

    // if (!paginacao) {
    //   console.warn('Paginator ainda não inicializado.');
    //   return;
    // }

    // if(!this.filtro.tipoEntidade) {
    //   this.messageService.error('Por favor, selecione um tipo de entidade.');
    //   return;
    // }

    if (!this.filtro.tipoEntidade) {
      this.messageService.error('Por favor, selecione um tipo de entidade.');
      return;
    }

    if (this.filtro.tipoEntidade == 9 && !this.filtro.subTipo) {
      this.messageService.error('Por favor, selecione um Subtipo de Entidade.');
      return;
    }

    const idEspecificacao = this.filtro.idEspecificacao ? this.filtro.idEspecificacao : undefined;
    this.dominiosService.consultarCargoHierarquia([this.filtro.tipoEntidade], this.filtro.subTipo, idEspecificacao, this.incluirInativos).subscribe((data) => {
      this.dataSet = data;
      // this.paginator.totalItens = data.totalElements;
    });
  }

  atualizarEstrutura(param: any) {
    if (param?.incluirInativos !== undefined) {
      this.incluirInativos = param.incluirInativos;
    }
    this.editarItem(param);
  }


  salvarItem(dataSet: any) {
    // this.ajustarObjDominioSalvar(item, RouteAction.Inserir);
    if (!dataSet.length) {
      this.service.cadastrarHierarquia(dataSet).subscribe({
        next: () => {
          this.messageService.success(`Domínio inserido com sucesso.`);
        },
        error: (err) => {
          if (Array.isArray(dataSet) && dataSet.length) {
            const idRemover = dataSet[dataSet.length - 1]?.id;
            if (idRemover) {
              this.dataSet = this.dataSet.filter((x: any) => x.id !== idRemover);
            }
            // else {
            //   this.dataSet = [];
            // }
          }
        }
      });
    } else {
      this.editarItem(dataSet);
    }
  }



  editarItem(dataSet: any) {
    // const node = item.node;
    // const values = item.values;

    // if (node) {
    //   node.tipoEntidade = this.tipoEntidadeList.find(x => x.id === values.tipoEntidade);
    //   node.cargoReferencia = this.cargoReferenciaList.find(x => x.id === values.cargoReferencia);
    // }

    // this.ajustarObjDominioSalvar(node, RouteAction.Editar);
    // console.log('Editar item:', dataSet);
    // if (!dataSet.length) {
    //   this.messageService.error('Nao foi encontrada uma lista.');
    //   return;
    // }
    const dataSetNovo = dataSet?.dataSet || dataSet;
    const dataSetEnvio = dataSetNovo.length ? dataSetNovo : [];

    // this.service.editarHierarquia(dataSetEnvio).subscribe(() => {
    //   this.messageService.success(`Domínio atualizado com sucesso.`);
    //   this.dataSet = dataSet;
    // });

    // **NOVO Formato
    // if (dataSetNovo.length === 0) {
    //   let idEntidade = this.filtro.tipoEntidade;
    //   let idSubTipoEntidade = this.filtro.subTipo;

    //   if (!idEntidade) {
    //     return this.messageService.error('Selecione um tipo de entidade.');
    //   }

    //   this.service.removerHierarquia(idEntidade, idSubTipoEntidade).subscribe(() => {
    //     this.messageService.success(`Domínio removido com sucesso.`);
    //     this.pesquisar();
    //   });
    // }

    // if (dataSetNovo.length > 0) {
      this.service.editarHierarquia(dataSetEnvio).subscribe({
        next: () => {
          this.messageService.success(`Domínio atualizado com sucesso.`);
          this.pesquisar();
        },
        error: (err) => {
          if (Array.isArray(dataSetNovo) && dataSetNovo.length) {
            const idRemover = dataSetNovo[dataSetNovo.length - 1]?.id;
            if (idRemover) {
              this.dataSet = this.dataSet.filter((x: any) => x.id !== idRemover);
            }
            // else {
            //   this.dataSet = [];
            // }
          }
        }
      });
    // }
  }



  ajustarObjDominioSalvar(item: any, acao: RouteAction): any {
    const itemAjustado = { ...item };
    if (itemAjustado?.tipoGrupo) {
      itemAjustado.tipoGrupo = itemAjustado?.tipoGrupo?.id;
    }
    itemAjustado.cargoReferenciaId = itemAjustado.cargoReferencia?.id || itemAjustado.cargoReferencia;
    itemAjustado.cargoSubordinadoId = itemAjustado.cargoSubordinadoId?.id || itemAjustado.cargoSubordinadoId;
    itemAjustado.tipoEntidadeId = itemAjustado.tipoEntidade?.id || itemAjustado.tipoEntidade;

    console.log('objEnvio', itemAjustado);

    // switch (acao) {
    //   case RouteAction.Inserir:
    //     this.service.cadastrar(this.nomeDominio, itemAjustado).subscribe(() => {
    //       this.messageService.success(`Domínio inserido com sucesso.`);
    //       this.voltar();
    //     });
    //     break;
    //   case RouteAction.Editar:
    //     this.service.editar(this.nomeDominio, itemAjustado.id, itemAjustado).subscribe(() => {
    //       this.messageService.success(`Domínio atualizado com sucesso.`);
    //     });
    //     break;
    // }
  }

  // removerItem(item: any) {
  //   console.log('Remover item:', item);
  //   this.dialogService.confirm(`Confirma a inativação do domínio: <br> <strong>${item.nomeCargoReferencia}</strong>?`, () => {
  //     const removerRecursivo = (lista: any[], idRemover: number): any[] => {
  //       return lista
  //         .filter((x: any) => x.id !== idRemover)
  //         .map((x: any) => ({
  //           ...x,
  //           children: x.children ? removerRecursivo(x.children, idRemover) : []
  //         }));
  //     };
  //     const dataSetAtualizado = removerRecursivo(this.dataSet, item.id);

  //     this.editarItem(dataSetAtualizado);
  //   });
  // }

  removerItem(item: any) {
    const message = `Confirma a remoção do domínio: <br> <strong>${item.nomeCargoReferencia}</strong>?`; //`Confirma a inativação do domínio: <br> <strong>${item.nomeCargoReferencia}</strong>?`;

    this.dialogService.confirm(
      message,
      () => {
        this.service.inativarItemNovo(item.id).subscribe({
          next: () => {
            this.messageService.success('Domínio inativado com sucesso.');
            this.consultar();
          },
          error: (err) => {
            console.error(err);
            this.messageService.error('Erro ao inativar domínio.');
          }
        });
      }
    );
  }


  reativarItem(item: any) {
    console.log('Reativar item:', item);
    // const tipoEntidadeId = this.filtro.tipoEntidade;
    // const idSubTipoEntidade = this.filtro.subTipo;
    // const idEspecificacaoSubTipoEntidade = this.filtro.idEspecificacao;

    // if (!tipoEntidadeId) {
    //   return this.messageService.error('Tipo de entidade não informado para reativação.');
    // }

    this.dialogService.confirm(
      `Confirma a reativação do domínio: <br> <strong>${item.nomeCargoReferencia}</strong>?`,
      () => {
        // this.service.reativarItem(tipoEntidadeId, idSubTipoEntidade, idEspecificacaoSubTipoEntidade).subscribe({
        this.service.reativarItemNovo(item.id).subscribe({
          next: () => {
            this.messageService.success('Domínio reativado com sucesso.');
            this.consultar(); // recarrega a estrutura
          },
          error: (err) => {
            console.error(err);
            this.messageService.error('Erro ao reativar domínio.');
          }
        });
      }
    );
  }


  removerSelecionados(ids: number[]) {
    const removerRecursivoMultiplos = (lista: any[], idsRemover: number[]): any[] => {
      return lista
        .filter((x: any) => !idsRemover.includes(x.id))
        .map((x: any) => ({
          ...x,
          children: x.children ? removerRecursivoMultiplos(x.children, idsRemover) : []
        }));
    };
    const dataSetAtualizado = removerRecursivoMultiplos(this.dataSet, ids);

    this.editarItem(dataSetAtualizado);
  }

  incluirPrincipal() {
    this.dominiosSharedDataService.setAdicionarDominioPrincipal(true);
  }

  paginacao(paginatorRef: PaginationComponent) {
    this.paginator = paginatorRef;

    if (this.pesquisaInicialRealizada) {
      this.consultar();
    }
  }

  resetForm() {
    this.dominioFilterForm.reset();
    this.pesquisar();
  }

  voltar() {
    window.history.back();
  }



  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    const sortField = itemSelected?.key;
    const sortOrder = itemSelected?.value;

    const sortParams = {
      sortField,
      sortOrder
    };

    if (sortField && sortOrder) {
      this.loadData(sortParams);
    }
  }

  loadData(sortParams?: any): void {
    let params = {};
    if (sortParams) {
      params = { ...sortParams };
    }

    this.dominiosService.consultarSort(this.nomeDominio, this.filtro, this.paginator.pagination, params).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }

  parametros() {
    this.route.data.subscribe((data) => {
      if (data['dominio']) {
        this.descricaoDominio = data['dominio'].descricao;
        console.log('Descrição do domínio:', this.descricaoDominio);
      }
    });
  }





  get tipoEntidadeControl(): any {
    return this.dominioFilterForm.get('tipoEntidade');
  }

  get subTipoControl(): any {
    return this.dominioFilterForm.get('subTipo');
  }

  // get especificacaoControl(): any {
  //   return this.dominioFilterForm.get('idEspecificacao');
  // }

  // get tipoEntidadeOrgao() {
  //   const orgao = 9;
  //   return this.dominioFilterForm.get('tipoEntidade')?.value === orgao;
  // }
}
